// extracted by mini-css-extract-plugin
export default {"PageDecorator":"PageDecorator_PageDecorator__VxZXk"};